import { gql } from "@apollo/client";

const HOMEPAGE_QUERY = gql`
  query Homepage($refresh: Boolean!) {
    homepage(refresh: $refresh) {
      ... on Homepage {
        downloads {
          dependencyStatus
          artifactStatus
          name
          event {
            created
            eventId
            message
            purpose
            qualname
            severity
            willRetry
          }
          pos {
            endColumn
            endLine
            path
            startColumn
            startLine
          }
          sparkline {
            status
            running
          }
        }
        refreshedAt
        sparklineFirstDate
        uploads {
          dependencyStatus
          artifactStatus
          event {
            created
            eventId
            message
            purpose
            qualname
            severity
            willRetry
          }
          name
          pos {
            endColumn
            endLine
            path
            startColumn
            startLine
          }
          sparkline {
            status
            running
          }
          destination
        }
      }
      ... on NoPublishedScriptbook {
        ok
      }
    }
  }
`;

const DOWNLOAD_DETAILS = gql`
  query DownloadDetails($downloadName: String!, $refresh: Boolean) {
    downloadDetails(downloadName: $downloadName, refresh: $refresh) {
      status
      event {
        created
        eventId
        message
        purpose
        qualname
        severity
        willRetry
      }
      pos {
        endColumn
        endLine
        path
        startColumn
        startLine
      }
      refreshedAt
      sparkline {
        running
        status
      }
      sparklineFirstDate
      scriptbookId
      keysUsedByDownload {
        name
        status
      }
      uploadsUsingDownload {
        name
        status
      }
    }
  }
`;

const UPLOAD_DETAILS = gql`
  query uploadDetails($uploadName: String!, $refresh: Boolean) {
    uploadDetails(uploadName: $uploadName, refresh: $refresh) {
      status
      event {
        created
        eventId
        message
        purpose
        qualname
        severity
        willRetry
      }
      destination
      pos {
        endColumn
        endLine
        path
        startColumn
        startLine
      }
      refreshedAt
      sparkline {
        running
        status
      }
      sparklineFirstDate
      scriptbookId
      keysUsedByUpload {
        name
        status
      }
      downloadsUsedByUpload {
        name
        status
      }
    }
  }
`;

export { DOWNLOAD_DETAILS, HOMEPAGE_QUERY, UPLOAD_DETAILS };
